import React, { useEffect, useRef } from "react";
import {
  getAdminUsersList,
  userActiveInactiveToggle,
  userInvitation,
  userRemove,
  fetchRoles,
} from "../../../API/api";
import { useDispatch, useSelector } from "react-redux";
import {
  Table,
  Spin,
  Tag,
  Switch,
  Pagination,
  Tooltip,
  Popconfirm,
} from "antd";
import { bindActionCreators } from "redux";
import { Actions } from "../../../Action/index";
import { momentit } from "../../../utils";
import { UserOutlined, EditOutlined } from "@ant-design/icons";
import { toast } from "react-toastify";

const statusType = [
  { text: "Active", value: "1" },

  { text: "InActive", value: "0" },
];

export default function UserList() {
  const manageUserState = useSelector((state) => state.manageUsers);
  const adminFilterState = useSelector((state) => state.cmRoot);
  const lastSortRef = useRef({ field: "createdDate", order: "desc" });
  const dispatch = useDispatch();
  const {
    getdataMU,
    updatePageNoMU,
    sortOrderMU,
    sortFilterMU,
    drawerOpenMU,
    selectedUserMU,
    updateDataMU,
    updateroleListMU,
    isLoadingAMU,
  } = bindActionCreators(Actions, dispatch);
  const requestIdRef = useRef(0);

  const fetchUsers = () => {
    if (adminFilterState.selecetdRoutingValue !== "") {
      const currentRequestId = ++requestIdRef.current;
      isLoadingAMU(true);
      getAdminUsersList(
        manageUserState.pageNo,
        manageUserState.pageSize,
        manageUserState.sortfilter,
        manageUserState.sortorder,
        manageUserState.search,
        adminFilterState.selectedRouting.value === "All"
          ? ""
          : adminFilterState.selectedRouting.id,
        adminFilterState.selectedRouting.value === "All"
          ? ""
          : adminFilterState.selectedGeoLevel?.length === 0
            ? ""
            : adminFilterState.selectedGeoLevel.value,
        manageUserState.userType.value === "all"
          ? ""
          : manageUserState.userType.value,
        manageUserState.role.value === "all" ? "" : manageUserState.role.value,
        manageUserState.fromdate === ""
          ? ""
          : new Date(manageUserState.fromdate).getTime(),
        manageUserState.tilldate === ""
          ? ""
          : new Date(manageUserState.tilldate).getTime(),
        manageUserState.domainFilter?.length === 0
          ? ""
          : manageUserState.domainFilter.map((dm) => dm.value).toString(),
        manageUserState.statusValue.value === "all"
          ? ""
          : manageUserState.statusValue.value,
        manageUserState.activefromdate === ""
          ? ""
          : new Date(manageUserState.activefromdate).getTime(),
        manageUserState.activetilldate === ""
          ? ""
          : new Date(manageUserState.activetilldate).getTime(),
      )
        .then((res) => {
          if (currentRequestId !== requestIdRef.current) return; // stale response — ignore

          if (res === undefined) {
            isLoadingAMU(false);
            return;
          }
          if (res.data.success) {
            if (manageUserState.roleList?.length === 0) {
              fetchRoles().then((res) => {
                if (res === undefined) return;
                updateroleListMU(
                  res.data.data.filter((role) => {
                    role.name = role.roleName;
                    role.value = role.roleId;
                    role.label = role.roleName;
                    return role.active;
                  }),
                );
              });
            }
            getdataMU(res.data.data);
          } else {
            isLoadingAMU(false);
          }
        })
        .catch(() => {
          if (currentRequestId !== requestIdRef.current) return;
          isLoadingAMU(false);
        });
    }
  };
  const activeInactiveUser = (flag, data) => {
    let payload = {
      userUuid: data.userUuid,
      status: flag ? "active" : "inactive",
    };
    let payloadTwo = {
      firstName: data.firstName,
      lastName: data.lastName,
      email: data.email,
      roles:
        data.roles === undefined || data.roles?.length === 0
          ? [{ roleName: "Seeker", roleId: 2 }]
          : data.roles,
      userType: data.userType,
    };
    if (!flag) {
      let filteredData = manageUserState.users.filter((user) => {
        if (user.userUuid === data.userUuid) {
          user.userStatus = flag ? "active" : "inactive";
        }
        return user;
      });
      userActiveInactiveToggle(payload).then((res) => {
        if (res === undefined) return;
        if (res.data.success) {
          updateDataMU(filteredData);
          fetchUsers();
          toast.success(() => {
            return (
              <>
                <span style={{ fontSize: "12px" }}>{res.data.message}</span>
              </>
            );
          });
        }
      });
    }
    if (flag) {
      let filteredData = manageUserState.users.filter((user) => {
        if (user.userUuid === data.userUuid) {
          user.userStatus = flag ? "active" : "inactive";
        }
        return user;
      });
      userInvitation([payloadTwo]).then((res) => {
        if (res === undefined) return;
        if (res.data.success) {
          updateDataMU(filteredData);
          fetchUsers();
          toast.success(() => {
            return (
              <>
                <span style={{ fontSize: "12px" }}>{res.data.message}</span>
              </>
            );
          });
        }
      });
    }
  };
  const onDeleteuser = (id) => {
    userRemove(id).then((res) => {
      if (res === undefined) return;
      if (res.data.success) {
        toast.success(() => {
          return (
            <>
              <span style={{ fontSize: "12px" }}>{res.data.message}</span>
            </>
          );
        });
        fetchUsers();
      }
    });
  };
  const renderTitle = (title, position = "center") => {
    return (
      <div style={{ textAlign: position }}>
        <span style={{ fontWeight: "500", fontSize: "17px" }}>{title}</span>
      </div>
    );
  };
  const showRoleList = (roles) => {
    if (roles === undefined) {
      return;
    }
    return (
      <>
        {roles.map((role) => {
          return (
            <Tag color="var(--light_color_shade)" style={{ fontSize: "10px" }}>
              {role.roleName}
            </Tag>
          );
        })}
      </>
    );
  };
  const onClickEdit = (data) => {
    selectedUserMU(data);
    drawerOpenMU(2);
  };
  const showDomainList = (domain) => {
    if (domain === undefined) {
      return;
    }
    const newDomain = domain.split(",");
    return (
      <>
        {/* <ul style={{height:'250px', overflow:'auto'}}> */}
        {newDomain.map((dm) => {
          return (
            <Tag color="var(--light_color_shade)" style={{ fontSize: "10px" }}>
              {dm}
            </Tag>
          );
        })}
        {/* </ul> */}
      </>
    );
  };

  const handleSortChange = (pagination, filters, sorter) => {
    if (!sorter.field || !sorter.order) {
      // antd cancelled back to "none" — take over and just flip direction ourselves,
      // keeping the same field that was last active
      const flipped = lastSortRef.current.order === "desc" ? "asc" : "desc";
      const sameField = lastSortRef.current.field;

      lastSortRef.current = { field: sameField, order: flipped };

      sortFilterMU(sameField);
      sortOrderMU(flipped);
      return;
    }

    const newOrder = sorter.order === "descend" ? "desc" : "asc";

    if (
      sorter.field === lastSortRef.current.field &&
      newOrder === lastSortRef.current.order
    ) {
      return; // synthetic/duplicate re-emit — ignore
    }

    lastSortRef.current = { field: sorter.field, order: newOrder };

    sortFilterMU(sorter.field);
    sortOrderMU(newOrder);
  };

  const columns = [
    {
      title: renderTitle("Name", "start"),
      dataIndex: "name",
      render: (_, row) => (
        <span
          style={{
            wordBreak: "break-word",
            overflowWrap: "break-word",
            fontSize: "15px",
            fontWeight: "300",
          }}
        >
          {row.firstName} {row.lastName}
        </span>
      ),
    },
    {
      title: renderTitle("Email ID", "start"),
      dataIndex: "email",
      render: (_, row) => (
        <span
          style={{
            wordBreak: "break-word",
            overflowWrap: "break-word",
            fontSize: "15px",
            fontWeight: "300",
          }}
        >
          {row.email}
        </span>
      ),
    },
    {
      title: renderTitle("Role", "start"),
      dataIndex: "roles",
      width: "10%",
      render: (_, row) => (
        <>
          {row.roles?.length !== 0 ? (
            <div
              style={{
                wordBreak: "break-word",
                overflowWrap: "break-word",
                fontSize: "15px",
                fontWeight: "300",
                cursor: "pointer",
              }}
            >
              <i
                className="fa fa-user-circle-o"
                style={{
                  fontSize: "18px",
                  color: `${row.roles?.length > 1 ? "#5b0086" : row.roles[0].roleName === "Seeker" ? "#34bef0" : row.roles[0].roleName === "Expert" ? "#fd7400" : row.roles[0].roleName === "CM" ? "#aa110e" : "#aa110e"}`,
                  background: "#fff",
                }}
              ></i>
              &nbsp;&nbsp;
              <Tooltip color="#FAFAFA" title={showRoleList(row.roles)}>
                <span>{row.roles[0].roleName}</span>
              </Tooltip>
              {row.roles?.length > 1 && (
                <span style={{ color: "#808080", fontSize: "12px" }}>
                  +{row.roles?.length - 1}
                </span>
              )}
            </div>
          ) : (
            <span style={{ fontSize: "12px", color: "#808080" }}>N/A</span>
          )}
        </>
      ),
    },
    {
      title: renderTitle("Status", "left"),
      dataIndex: "userStatus",
      width: "10%",

      render: (_, row) => (
        <div
          style={{
            wordBreak: "break-word",
            overflowWrap: "break-word",
            fontSize: "15px",
            fontWeight: "300",
            textAlign: "left",
          }}
        >
          {row.userStatus === "active" ? (
            <Tag color="green">Active</Tag>
          ) : (
            <Tag color="red">Inactive</Tag>
          )}
        </div>
      ),
    },
    {
      title: renderTitle("Domain", "start"),
      dataIndex: "domains",
      width: "15%",
      render: (_, row) => (
        <div
          style={{
            wordBreak: "break-word",
            overflowWrap: "break-word",
            fontSize: "15px",
            fontWeight: "300",
            textAlign: "start",
          }}
        >
          {row.domains !== undefined && row.domains.split(",")?.length > 0 ? (
            <Tooltip
              color="#FAFAFA"
              placement="right"
              title={showDomainList(row.domains)}
            >
              <span style={{ cursor: "pointer" }}>
                <Tag
                  color="var(--light_color_shade)"
                  style={{ marginRight: "1px" }}
                >
                  {row.domains.split(",")[0]}
                </Tag>
                {row.domains.split(",")?.length > 1 && (
                  <span
                    style={{
                      fontSize: "12px",
                      color: "#808080",
                      fontWeight: "300",
                    }}
                  >
                    +{row.domains.split(",")?.length - 1}
                  </span>
                )}
              </span>
            </Tooltip>
          ) : (
            <span style={{ fontSize: "12px", color: "#808080" }}>N/A</span>
          )}
        </div>
      ),
    },
    {
      title: renderTitle("Last Active", "center"),
      dataIndex: "lastActive",
      width: "13%",
      // sortDirections: ["ascend", "descend"],
      sortOrder:
        manageUserState.sortfilter === "lastActive"
          ? manageUserState.sortorder === "desc"
            ? "descend"
            : "ascend"
          : false,
      sorter: (a, b) => a.lastActive - b.lastActive,
      render: (_, row) => (
        <div
          style={{
            wordBreak: "break-word",
            overflowWrap: "break-word",
            fontSize: "15px",
            fontWeight: "300",
            textAlign: "center",
          }}
        >
          {row.lastActive ? momentit(row.lastActive) : "Never"}
        </div>
      ),
    },
    {
      title: renderTitle("User Since", "center"),
      dataIndex: "createdDate",
      width: "13%",
      // sortDirections: ["ascend", "descend"],
      sortOrder:
        manageUserState.sortfilter === "createdDate"
          ? manageUserState.sortorder === "desc"
            ? "descend"
            : "ascend"
          : false,
      sorter: (a, b) => a.createdDate - b.createdDate,
      render: (_, row) => (
        <div
          style={{
            wordBreak: "break-word",
            overflowWrap: "break-word",
            fontSize: "15px",
            fontWeight: "300",
            textAlign: "center",
          }}
        >
          {momentit(row.createdDate)}
        </div>
      ),
    },
    {
      title: renderTitle("", "center"),
      dataIndex: "actions",
      width: "10%",
      render: (_, row) => (
        <div
          style={{
            wordBreak: "break-word",
            overflowWrap: "break-word",
            fontSize: "15px",
            fontWeight: "300",
            textAlign: "center",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <span>
            <i
              style={{
                fontSize: "20px",
                marginTop: "2px",
                color: "grey",
                cursor: "pointer",
              }}
              onClick={() => onClickEdit(row)}
              className="fa fa-pencil-square-o"
            ></i>
          </span>
          &nbsp;&nbsp;
          {row.userStatus === "active" && (
            <span>
              <Popconfirm
                title="Delete the user?"
                description="Are you sure to remove this user?"
                okText="Yes"
                cancelText="No"
                onConfirm={() => onDeleteuser(row.userUuid)}
              >
                <i
                  style={{ fontSize: "20px", color: "grey", cursor: "pointer" }}
                  className="fa fa-trash-o"
                ></i>
              </Popconfirm>
            </span>
          )}
          &nbsp;&nbsp;
          <span style={{ marginTop: "-4px" }}>
            <Switch
              checked={row.userStatus === "active"}
              onChange={(e) => activeInactiveUser(e, row)}
              size="small"
            />
          </span>
        </div>
      ),
    },
  ];

  useEffect(() => {
    fetchUsers();
  }, [
    manageUserState.pageNo,
    manageUserState.pageSize,
    manageUserState.search,
    manageUserState.sortorder,
    manageUserState.reload,
    adminFilterState.selectedRouting,
    adminFilterState.selectedGeoLevel,
    manageUserState.userType,
    manageUserState.role,
    manageUserState.fromdate,
    manageUserState.tilldate,
    manageUserState.activefromdate,
    manageUserState.activetilldate,
    manageUserState.domainFilter,
    manageUserState.statusValue,
    manageUserState.sortfilter,
  ]);

  return (
    <>
      <Spin spinning={manageUserState.isLoading}>
        <Table
          columns={columns}
          className="mt-3"
          dataSource={manageUserState.users}
          pagination={false}
          rowClassName={(record, index) =>
            index % 2 === 0 ? "table-row-light" : "table-row-dark"
          }
          style={{ boxShadow: "7px 7px 20px lightgrey" }}
          onChange={handleSortChange}
        />
        <Pagination
          style={{
            display: "flex",
            justifyContent: "end",
            borderTop: "1px solid #f0f0f0",
            background: "#fafafa",
            width: "100%",
            paddingBlock: "10px",
            boxShadow: "10px 10px 20px lightgrey",
          }}
          defaultCurrent={manageUserState.pageNo + 1}
          showSizeChanger={false}
          current={manageUserState.pageNo + 1}
          pageSize={manageUserState.pageSize}
          total={manageUserState.totalCount}
          onChange={(e) => updatePageNoMU(e - 1)}
          disabled={manageUserState.isLoading}
        />
      </Spin>
    </>
  );
}
